import axios from 'axios';

export const moduleFastPayment = {
	state() {
		return {
			fastPaymentType: null,
			acceptation: false,
			amount: null,
			accountNumber: null,
			paymentLoadingButton: false,
		};
	},
	mutations: {
		setFastPaymentType(state, data) {
			state.fastPaymentType = data;
		},
		setAcceptation(state, data) {
			state.acceptation = data;
		},
		setAmount(state, data) {
			state.amount = data;
		},
		setAccountNumber(state, data) {
			state.accountNumber = data;
		},
		setPaymentLoadingButton(state, data) {
			state.paymentLoadingButton = data;
		},
	},
	getters: {
		getFastPaymentType: (state) => state.fastPaymentType,
		getAcceptation: (state) => state.acceptation,
		getAmount: (state) => state.amount,
		getAccountNumber: (state) => state.accountNumber,
		getPaymentLoadingButton: (state) => state.paymentLoadingButton,
	},
	actions: {
		fastPayment({ state, commit, dispatch }) {
			commit('setGlobalErrorMessage', '');

			var fastPaymentData = {
				fastPaymentType: state.fastPaymentType,
				acceptation: state.acceptation,
				amount: state.amount,
				accountNumber: state.accountNumber || null,
			};
			dispatch('newLogoutTime');
			return axios.post('FastPayment', fastPaymentData).then(
				(response) => {
					if (response.data.isFormData) {
						const form = document.createElement('form');
						form.method = 'POST';
						form.action = response.data.url;
						for (let [key, value] of Object.entries(
							response.data.formFields
						)) {
							const input = document.createElement('input');
							if (key === 'Signature') {
								value = value.replace(/\\r\\n/g, '\r\n');
							}
							input.type = 'hidden';
							input.name = key;
							input.value = value;
							form.appendChild(input);
						}
						document.body.appendChild(form);
						form.submit();
						setTimeout(() => form.remove(), 600);
					} else {
						window.location.href = response.data.url;
					}
				},
				(e) => {
					commit('setPaymentLoadingButton', false);
					/* TODO, może jakaś jedna funkcja zczytująca errory dla każdej 400 */
					if (e.status === 400) {
						if (
							typeof e.data !== typeof undefined &&
							typeof e.data.errors !== typeof undefined
						) {
							var errors = e.data.errors;
							var msg = '';
							for (const key of Object.keys(errors)) {
								msg += errors[key] + '\n';
							}
							commit('setGlobalErrorMessage', msg);
						}
					} else {
						commit(
							'setGlobalErrorMessage',
							'Bład aplikacji, skontaktuj się z dostawcą'
						);
					}
					window.scroll({
						top: 0,
						left: 0,
						behavior: 'smooth',
					});
				}
			);
		},
	},
};
